// Gradient helpers ported from the mockup (grad / photo) plus a stable
// doc-id -> hue mapping so a club or user always gets the same colors.

const HUES = [
  [47, 107, 255], [139, 92, 246], [34, 181, 115], [245, 166, 35], [245, 69, 59], [0, 137, 255],
  [18, 63, 224], [236, 72, 153], [20, 184, 166], [99, 102, 241], [217, 119, 6], [5, 18, 71],
];

/** Stable hash of a Firestore doc id (or any string) to a hue index 0..HUES.length-1. */
export function hueFor(id) {
  const s = String(id ?? "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h % HUES.length;
}

/** CSS linear-gradient for hue index i (angle a). */
export function grad(i = 0, a = 135) {
  const n = Math.abs(Math.trunc(i)) || 0;
  const c = HUES[n % HUES.length];
  const d = HUES[(n + 5) % HUES.length];
  return `linear-gradient(${a}deg,rgb(${c}) 0%,rgb(${d.map((v) => Math.round(v * 0.55))}) 100%)`;
}

/** Placeholder "photo" background (layered radial highlights over grad). */
export function photo(i = 0) {
  const n = Math.abs(Math.trunc(i)) || 0;
  return `radial-gradient(circle at ${20 + ((n * 37) % 60)}% ${25 + ((n * 23) % 50)}%,rgba(255,255,255,.35),transparent 38%),radial-gradient(circle at ${70 - ((n * 13) % 40)}% 80%,rgba(255,200,120,.35),transparent 45%),${grad(n, 160)}`;
}
